var $cedee0e66b175529$exports = {};
$cedee0e66b175529$exports = {
  "ascending": "rastu\u0107i",
  "ascendingSort": function ascendingSort(args) {
    return "sortirano po kolonama ".concat(args.columnName, " rastu\u0107im redosledom");
  },
  "columnSize": function columnSize(args) {
    return "".concat(args.value, " piksela");
  },
  "descending": "padaju\u0107i",
  "descendingSort": function descendingSort(args) {
    return "sortirano po kolonama ".concat(args.columnName, " padaju\u0107im redosledom");
  },
  "resizerDescription": "Pritisnite Enter da biste zapo\u010Deli promenu veli\u010Dine",
  "select": "Izaberite",
  "selectAll": "Izaberite sve",
  "sortable": "kolona koja se mo\u017Ee sortirati"
};
export { $cedee0e66b175529$exports as default };